export const ClientListActions = Object.freeze({
  FINISH_ENROLLING: 'finish_enrolling',
  VIEW_SCREENER_RESULTS: 'view_screener_results',
  REINVITE_TO_DOWNLOAD: 'reinvite_to_download'
})
